import { render, staticRenderFns } from "./actual-investor-related-content-panel.vue?vue&type=template&id=7386ae3d&"
var script = {}
import style0 from "../../../../assets/styles/panels/_ActualInvestorRelatedContentPanel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports